var sharedConfig = {
  jsAssetVersion: '-v94',
  midocoAgent: 'Midoco GmbH',
  wowcherCode: 'WL997'
}

module.exports = sharedConfig
